import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const CHAT_DECLINE_EVENT_NAMES = {
  CLICK_DECLINE_REASON: 'click_decline_reason',
  SEND_DECLINE_REASON: 'click_send_decline_reason',
};

export const trackClickDeclineReason = (
  reason,
  selectedAlertID,
  irpVersion,
) => {
  gspx.trackEvent({
    name: CHAT_DECLINE_EVENT_NAMES.CLICK_DECLINE_REASON,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Click ${reason} from decline alert`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
    entities: {
      alert_id: selectedAlertID,
    },
  });
};

export const trackSendDeclineReason = (reason, selectedAlertID, irpVersion) => {
  gspx.trackEvent({
    name: CHAT_DECLINE_EVENT_NAMES.SEND_DECLINE_REASON,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Click send ${reason} from decline alert`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
    entities: {
      alert_id: selectedAlertID,
    },
  });
};
